// raygun does not send in these environment
// Empty to test locally
const excludedHostnames = ['localhost']

// These tags will be send to Raygun
const tags = [window.location.hostname]

const prepareRaygun = function(payload) {
	// modify raygun object
	payload.Details.tags = tags
	// not sure we are allowed to log this, as there may be sensitive data
	delete payload.Details.User
	delete payload.Details.Request
	delete payload.Details.Breadcrumbs
}

export default {
	install(Vue, options) {
		if (process.env.NODE_ENV === 'production') {
			// Raygun is not loaded unless it is a production environment, as it wrecks havoc on console.log file and line number references
			// It is done this way as simply importing raygun4js activates the offending code
			import('raygun4js')
				.then(raygunModule => {
					return raygunModule.default
				})
				.then(rg4js => {
					rg4js('apiKey', options.key)

					rg4js('setVersion', options.version)

					rg4js('options', {
						ignoreAjaxAbort: true,
						ignoreAjaxError: true,
						wrapAsynchronousCallbacks: false,
						disableAnonymousUserTracking: true,
						ignore3rdPartyErrors: true,
						disablePulse: true,
						excludedHostnames: excludedHostnames
					})

					rg4js('onBeforeSend', function(payload) {
						prepareRaygun(payload)
						return payload // Return false here to abort the send
					})

					Vue.prototype.$sendError = function(payload) {
						rg4js('send', payload)
					}
				})
		} else {
			Vue.prototype.$sendError = function(payload) {
				// Raygun disabled on non-production build
				console.error('Ignoring errors in debug mode', payload)
			}
		}
	}
}
